import { render, staticRenderFns } from "./ScoringControlSlider.vue?vue&type=template&id=263a2aa0"
import script from "./ScoringControlSlider.vue?vue&type=script&lang=js"
export * from "./ScoringControlSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports